/**
 * Smart Wishlist app page (/a/wishlist): inject a primary "View product" link per card.
 * Add-to-cart is hidden in component-wishlist-page.css so buyers choose options on the PDP.
 */

const getViewProductLabel = () => {
  const fromTheme = window.__pawsomeWishlistPage?.viewProduct;

  if (typeof fromTheme === 'string' && fromTheme.trim()) {
    return fromTheme.trim();
  }

  return 'View product';
};

const injectViewProductButtons = (root) => {
  if (!root) {
    return;
  }

  const label = getViewProductLabel();

  for (const card of root.querySelectorAll('#bookmarks .product')) {
    if (card.querySelector('.wishlistpage__view-product')) {
      continue;
    }

    const titleLink = card.querySelector('.product_title a[href]');

    if (!titleLink) {
      continue;
    }

    const href = titleLink.getAttribute('href');

    if (!href) {
      continue;
    }

    const buttons = card.querySelector('.buttons');

    if (!buttons) {
      continue;
    }

    const a = document.createElement('a');
    a.className = 'btn btn-primary wishlistpage__view-product';
    a.href = href;
    a.textContent = label;
    buttons.appendChild(a);
  }
};

const setupWishlistPageViewProduct = () => {
  const root = document.querySelector('.wishlistpage');

  injectViewProductButtons(root);

  if (!root) {
    return;
  }

  const mo = new MutationObserver(() => {
    injectViewProductButtons(root);
  });

  mo.observe(root, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupWishlistPageViewProduct, { once: true });
} else {
  setupWishlistPageViewProduct();
}
